var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.landingInfo.chain && _vm.landingInfo.chain !== 'mainnet')?_c('div',{staticClass:"ve-corner-marker"},[_c('span',[_vm._v(_vm._s(_vm.landingInfo.chain && _vm.$t(`app.${_vm.landingInfo.chain}`)))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }